export const getDevices = (devices, dataType = 'monetization') => {
    // return ['DESKTOP', 'TABLET'] when Web is selected.
    // return empty list with all devices are selected.
    if(devices.length === 2){
        return []
    }
    else if(devices.length === 1 && devices[0] === 'DESKTOP' && dataType !== 'monetization'){
        return ['Desktop', 'Tablet']
    } 
    else {
        return devices;
    }
}

/**
 * string helper that returns filter dropdown label text
 * with '/' as a delimiter
 *
 * @param data
 * @returns {string}
 */
export const getSiteAndAppFilterName = data => {
    let outputStr = '';
    const types = Object.keys(data)
        .filter(type => Object.keys(data[type]).length)
        .map((type, i, arr) => {
            return type[0].toUpperCase() + type.substring(1) + ((arr.length - 1 !== i) ? '/' : '');
        });
    return outputStr.concat(...types || '');
}